import EventJson from './interfaces/EventJson'
import EventTranslation from './EventTranslation'
import { Locales } from 'src/i18n'
import Translatable from '../shared/interfaces/Translatable'

export default class Event implements Translatable {
  id: number
  timezone: string
  currency: string
  countryCode: string
  translations: { [locale: string]: EventTranslation }

  constructor(
    id: number,
    timezone: string,
    currency: string,
    countryCode: string,
    translations: { [locale: string]: EventTranslation },
  ) {
    this.id = id
    this.timezone = timezone
    this.currency = currency
    this.countryCode = countryCode
    this.translations = translations
  }

  findTranslationByLocale(locale: Locales): EventTranslation | null {
    return this.translations[locale] ?? null
  }

  translate(locale: Locales, fallbackLocale: Locales) {
    let translation = this.findTranslationByLocale(locale)

    if (!translation) {
      translation = this.findTranslationByLocale(fallbackLocale)
    }

    return translation
  }

  static fromJson(data: EventJson) {
    return new this(
      data.id,
      data.timezone,
      data.currency,
      data.countryCode,
      data.translations.reduce(
        (previous, current) => ({
          ...previous,
          [current.locale]: EventTranslation.fromJson(current),
        }),
        {},
      ),
    )
  }

  toJson(): EventJson {
    return {
      id: this.id,
      timezone: this.timezone,
      currency: this.currency,
      countryCode: this.countryCode,
      translations: Object.values(this.translations).map((t) => t.toJson()),
    }
  }
}
